window.Timesheet = {
    id: null,
    creating: false,
    year: '',
    week: '',
    start: '',
    total_hours: 0,
    view_only: false,
    person: '',
    entries: [],
    status_note: '',
    valid_entry_dates: [],
    status: 'requires_attention',
    getEntriesByDate: function(date){
        return _.filter(this.entries, function (entry) {
            return entry.date == date;
        });
    },
    fromNew: function (entryRequirements) {
        var that = this;
        this.creating = true;
        this.year = entryRequirements.year;
        this.week = entryRequirements.week;
        this.entries = [];
        this.valid_entry_dates = entryRequirements.entries;
        this.total_hours = 0;
        this.start = entryRequirements.entries[0];
        this.status = 'requires_attention';
        this.view_only = false;

        _.forEach(entryRequirements.entries, function (entry) {
            that.addEntry(entry);
        });

        return this;
    },
    fromExisting: function (sheet) {
        var that = this;
        this.view_only = sheet.view_only;
        this.creating = false;
        this.year = sheet.year;
        this.week = sheet.week;
        this.entries = [];
        this.valid_entry_dates = sheet.valid_date_entries;
        this.total_hours = sheet.total_hours;
        this.start = sheet.start;
        this.status = sheet.status;
        this.status_note = sheet.status_note;
        this.id = sheet.id;
        this.person = sheet.person.data.name;

        _.forEach(sheet.entries.data, function (entry) {
            that.entries.push(entry);
        });

        return this;
    },
    addEntry: function (date) {
        this.entries.push({
            "date": date
        });

        return this;
    },
    deleteEntry: function (entry) {
        this.entries.splice(this.entries.indexOf(entry), 1);

        return this;
    }
};